'use client';

import React, { useEffect, useState } from 'react';
import { Box, Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import VideoPlayer from '../venue/[slug]/video_player';

interface VideoModalProps {
    videoUrl: string;
    title?: string;
    open: boolean;
    onClose: () => void;
    autoPlay?: boolean;
}

const VideoModal: React.FC<VideoModalProps> = ({ videoUrl, title, open, onClose, autoPlay = false }) => {
    const [modalOpen, setModalOpen] = useState(false);

    // Sync the internal state with the prop
    useEffect(() => {
        setModalOpen(open);
    }, [open]);

    const handleClose = () => {
        setModalOpen(false);
        onClose();
    };

    // Detect escape key to close the modal
    useEffect(() => {
        const handleEsc = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                handleClose();
            }
        };

        if (modalOpen) {
            window.addEventListener('keydown', handleEsc);
        }

        return () => {
            window.removeEventListener('keydown', handleEsc);
        };
    }, [modalOpen]);

    return (
        <Modal
            open={modalOpen}
            onClose={handleClose}
            aria-labelledby="video-modal-title"
            aria-describedby="video-modal-description"
            closeAfterTransition
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: { xs: '95%', sm: '90%', md: '80%' },
                    maxWidth: '1000px',
                    bgcolor: '#000',
                    border: '1px solid #444',
                    borderRadius: 2,
                    boxShadow: 24,
                    p: { xs: 2, sm: 3 },
                }}
            >
                <Box sx={{ position: 'relative' }}>
                    <IconButton
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: -16,
                            top: -16,
                            color: 'white',
                            bgcolor: 'rgba(0,0,0,0.6)',
                            zIndex: 1,
                            '&:hover': {
                                bgcolor: 'rgba(0,0,0,0.8)',
                            },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    <VideoPlayer videoUrl={videoUrl} title={title} autoPlay={autoPlay} />
                </Box>
            </Box>
        </Modal>
    );
};

export default VideoModal; 